/**
 * Scroll Animations — IntersectionObserver-based fade-in
 */

export const ScrollAnimations = {
	_observer: null,

	init() {
		if ( ! ( 'IntersectionObserver' in window ) ) {
			// Fallback: show everything
			document.querySelectorAll( '.fade-in' ).forEach( ( el ) => {
				el.classList.add( 'is-visible' );
			} );
			return;
		}

		this._observer = new IntersectionObserver(
			( entries ) => {
				entries.forEach( ( entry ) => {
					if ( entry.isIntersecting ) {
						entry.target.classList.add( 'is-visible' );
						this._observer.unobserve( entry.target );
					}
				} );
			},
			{ threshold: 0.05, rootMargin: '0px 0px -20px 0px' }
		);

		this.observe();
	},

	/**
	 * (Re-)observe all .fade-in elements that aren't visible yet.
	 * Call after DOM changes (e.g. parallax wrapping content).
	 */
	observe() {
		if ( ! this._observer ) return;

		document.querySelectorAll( '.fade-in:not(.is-visible)' ).forEach( ( el ) => {
			this._observer.observe( el );
		} );
	},
};
